var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/TrusteSeals/DirectDebitLogo.tsx",
  _this = this;
import React from 'react';
var DirectDebitLogo = function DirectDebitLogo() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "sm-truste-seals__svg",
    width: "100px",
    height: "34px",
    viewBox: "0 0 100 34",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 7
    }
  }, "DirectDebitLogo"), /*#__PURE__*/React.createElement("desc", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 7
    }
  }, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "DirectDebitLogo",
    fill: "#231F20",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,7.6 L52.2,7.6 C52.2,7.6 57.3,7.5 57.3,12.2 C57.2,15.7 52.3,16.2 52.3,16.2 L47,16.2 L47,7.6 L47,7.6 Z M62.6,24.4 C62.7,25.1 63.2,25.8 64.9,25.9 C67.1,26 68.3,25.1 68.3,25.1 L68.3,26.7 C68.3,26.7 65.9,27.3 64.8,27.3 C63.6,27.3 60.1,27 60.1,23.8 C60.1,21.2 63,20.3 64.7,20.3 C67.6,20.4 69,21.4 69,24.4 C68.8,24.4 64,24.4 62.6,24.4 L62.6,24.4 Z M62.6,23.1 L66.6,23.1 C66.6,23.1 66.6,21.6 64.7,21.6 C63.2,21.6 62.7,22.3 62.6,23.1 L62.6,23.1 Z M75.2,21.4 C75.8,20.8 76.7,20.3 78.4,20.3 C81.6,20.3 82.1,23 82.1,23.7 C82,24.4 81.8,27.2 78.1,27.2 C76.7,27.2 75.8,26.7 75.3,26.1 L75.3,27 L72.8,27 L72.8,17.7 L75.3,17.7 L75.3,21.4 L75.2,21.4 Z M77.3,25.8 C78.8,25.7 79.5,24.5 79.5,23.8 C79.5,23.2 79.1,21.9 77.2,21.9 C75.7,21.9 75.3,23 75.1,23.6 L75.1,24.3 C75.3,24.8 75.7,25.8 77.3,25.8 L77.3,25.8 Z M99.3,25.5 L99.4,27 C99.4,27 98.2,27.3 97.4,27.3 C96.6,27.3 94.6,26.8 94.6,24.9 C94.6,24.1 94.6,23 94.6,21.9 L92.5,21.9 L92.5,20.6 L94.6,20.6 C94.6,19.7 94.6,19 94.6,19 L97.2,19 L97.2,20.6 L99.3,20.6 L99.3,21.9 L97.2,21.9 L97.2,24.5 C97.2,24.5 97.2,25.8 98.2,25.8 C99.2,25.7 99.3,25.5 99.3,25.5 L99.3,25.5 Z M91.4,9 L94.4,9 L94.4,16.2 L96.9,16.2 L96.9,9 L100,9 L100,7.5 L91.4,7.5 L91.4,9 L91.4,9 Z M90.4,9.4 L90.7,7.9 C90.7,7.9 89.4,7.3 87.1,7.3 C84.9,7.3 81.3,8.5 81.3,11.9 C81.3,15.2 85.1,16.4 87.4,16.4 C89.7,16.4 90.5,16 90.5,16 L90.2,14.3 C90.2,14.3 89.2,14.6 87.4,14.6 C85.7,14.5 83.9,13.2 83.9,11.7 C84,10.4 85.5,8.8 87.5,8.8 C89.2,8.9 90.4,9.4 90.4,9.4 L90.4,9.4 Z M67.4,7.6 C67.4,7.6 71.7,7.4 71.7,9.9 C71.7,12 69.3,12.2 69.3,12.2 C69.3,12.2 70,12.3 70.3,12.8 C70.6,13.2 72.3,16.3 72.3,16.3 L69.7,16.3 C69.7,16.3 69.3,15.8 69.1,15.4 C68.9,15 68.5,14.3 68.5,14.3 C68.5,14.3 68.1,13 66.9,13 C66.9,13 66.4,13 66,13 L66,16.4 L63.5,16.4 L63.5,7.7 L67.4,7.7 L67.4,7.6 Z M65.8,11.5 L67.1,11.5 C67.1,11.5 69,11.4 69.1,10.3 C69.2,9.2 67.3,9.1 67.3,9.1 L65.8,9.1 L65.8,11.5 L65.8,11.5 Z M76.2,12.8 L80.4,12.8 L80.4,11.2 L76.2,11.2 L76.2,9.2 L80.7,9.2 L80.7,7.5 L73.6,7.5 L73.6,16.2 L80.7,16.2 L80.7,14.6 L76.1,14.6 L76.1,12.8 L76.2,12.8 Z M86.4,19.4 L88.9,19.4 L88.9,17.6 L86.4,17.6 L86.4,19.4 L86.4,19.4 Z M86.4,27 L88.9,27 L88.9,20.4 L86.4,20.4 L86.4,27 L86.4,27 Z M58.7,16.2 L61.2,16.2 L61.2,7.5 L58.7,7.5 L58.7,16.2 L58.7,16.2 Z M47,18.4 L52.2,18.4 C52.2,18.4 57.3,18.3 57.3,23 C57.2,26.5 52.3,27 52.3,27 L47,27 L47,18.4 L47,18.4 Z M49.6,25.3 L51.3,25.3 C51.3,25.3 54.7,25.1 54.7,22.4 C54.7,19.8 51.1,19.5 51.1,19.5 L49.6,19.5 L49.6,25.3 L49.6,25.3 Z M49.6,14.6 L51.3,14.6 C51.3,14.6 54.7,14.3 54.7,11.7 C54.7,9 51.1,8.8 51.1,8.8 L49.6,8.8 L49.6,14.6 L49.6,14.6 Z",
    id: "Shape",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,12.8 L23.8,30.2 C23.8,30.2 13.7,28.4 13.7,21.5 C13.7,15.9 21.1,13.5 23.8,12.8 L23.8,12.8 Z M23.8,12.4 C17.7,12 4,14.8 4,21 C4,25 11.3,31 23.1,31.1 C23.6,31.1 37,30.6 36.8,16.2 C36.6,4.1 27.5,2 24.6,1.6 L24.6,0.9 C36.2,1.6 45.2,8.6 45.2,17 C45.2,25.9 35,33.2 22.5,33.2 C10.1,33.2 0,25.9 0,17 C0,8.1 10.1,0.8 22.6,0.8 C23,0.8 23.4,0.8 23.7,0.8 L23.7,12.4 L23.8,12.4 Z",
    id: "Shape",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 11
    }
  }))));
};
export default DirectDebitLogo;
//# sourceMappingURL=DirectDebitLogo.js.map